import magikApi from "magik-api"

export const api = magikApi()
  .baseUrl("/api")
  .trailingSlash(true)
  .authHeaders((token) => ({
    Authorization: `Bearer ${token}`,
  }))
